<template>
  <div class="pinwall__search-list">
    <ul>
      <li
        v-for="item in items"
        :key="item.id"
        :title="item.title && item.title !== 'null' ? item.title : ''"
      >
        <Post :post="item" :withComments="false" :mode="'screen'"></Post>
        <p v-html="item.title && item.title !== 'null' ? item.title : ''"></p>
        <b-button type="light" @click="$emit('add', item)">Add</b-button>
        <b-button type="light" @click="$emit('select', item)">Select</b-button>
      </li>
    </ul>
  </div>
</template>

<script>
import Post from "./Post.vue";

export default {
  name: "search-List",
  props: {
    items: {
      type: Array
    }
  },
  components: {
    Post
  },
  methods: {
    addItem(item) {
      this.$emit("add", item);
    },
    selectItem(item) {
      this.$emit("select", item);
    }
  }
};
</script>
